export type MainSliderDetailLocationState = {
  from?: string;
};

export const MAIN_SLIDER_RETURN = {
  home: "/",
} as const;

export function getMainSliderReturnTo(state: unknown): string | undefined {
  if (!state || typeof state !== "object" || !("from" in state)) return undefined;
  const from = (state as MainSliderDetailLocationState).from;
  return typeof from === "string" && from.startsWith("/") ? from : undefined;
}

export function mainSliderDetailState(from: string): MainSliderDetailLocationState {
  return { from };
}
